import Promise from 'bluebird'

import { browserHistory } from 'react-router'

import { connect } from 'react-redux'

import {
  getTaxSerials,
} from 'reduxpath/ducks/Tax/List'

import {
  setTaxSerial,
  setLoadState,
  setData,
} from 'reduxpath/ducks/Tax/Add'

import Add from './units'

const mapStateToProps = state => ({
  data: state.TaxAdd.data,
})

const mapDispatchToProps = dispatch => ({
  handleFormChange(data) {
    return (e) => {
      const params = {
        data: {
          ...data,
          [e.target.name]: e.target.value,
        },
      }
      dispatch(setData(params))
    }
  },

  handleCancel() {
    browserHistory.push('/tax')
  },

  addTaxSerial(data) {
    return (e) => {
      e.preventDefault()
      const {
        frontDigit,
        midDigit,
        backDigit,
        lowestLimit,
        highestLimit,
      } = data

      const range = [...Array(1 + (highestLimit - lowestLimit)).keys()]
      Promise.map(range, (r) => {
        const params = {
          serialNumber: `${frontDigit}.${midDigit}-${backDigit}.${r + Number(lowestLimit)}`,
          isUsed: false,
        }
        dispatch(setTaxSerial(params, taxSerial => taxSerial))
      })
      .then(() => {
        dispatch(getTaxSerials({
          sort: {
            serialNumber: 'ASC',
            isUsed: 'ASC',
          },
          limit: 10,
          skip: 0,
        }))
        dispatch(setLoadState(false))
        browserHistory.push('/tax')
      })
      .catch((error) => {
        console.log('error', error) // eslint-disable-line
      })
    }
  },
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Add)
